import React, { useEffect } from 'react';

import SettingsModal from 'src/component/UI/SettingsModal/SettingsModal';

import { useSelector, useDispatch } from 'react-redux';
import { fromJS } from 'immutable';

import { fetchIntegrations } from 'src/module/integration/action';
import { getIntegrations } from 'src/module/integration/selector';
import { setSettingsModalClose } from 'src/module/device/action';
import { getSettingsModal } from 'src/module/device/selector';
import { SettingsModalTypes } from 'src/component/UI/SettingsModal/SettingsModalTypes';
import { addCommLoop } from 'src/module/device/action';
import { useTranslation } from 'src/i18n';


export default function AddCommLoopModal () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const integrations = useSelector(getIntegrations);
  const settingsModal = useSelector(getSettingsModal(null));
  useEffect(() => {
    dispatch(fetchIntegrations());
    dispatch(setSettingsModalClose(null));
  }, []);

  let frogName = null, frogId = null;
  const frogClients = [];
  integrations?.forEach(integration => {
    if (integration.get('type') === 'frog') {
      frogId = integration?.get('id');
      frogName = integration?.getIn(['settings', 'name']) || frogId.substring(0, 5);
      frogClients.push({ label: frogName, value: frogId });
    }
  });

  const commLoopFields = {
    frog_client_id: {
      type: 'select',
      label: t('commLoops.assignedSupervisorClient'),
      options: frogClients,
      errorText: t('common.required')
    },
    ip_address: {
      type: 'text',
      label: t('commLoops.ipAddress'),
      errorText: t('common.required'),
    },
    port: {
      type: 'text',
      label: t('commLoops.port'),
      errorText: t('common.required')
    }
  };

  const handleClose = () => {
    dispatch(setSettingsModalClose(null));
  };

  const commLoopModalSubmit = (rec: any) => {
    let port = rec.get('port', null);
    if (port) {
      port = parseInt(port);
    }
    rec = rec.set('port', port);
    dispatch(addCommLoop(rec));
  };

  return (
    <SettingsModal
      open={settingsModal?.get('isOpen') && settingsModal?.get('id') === SettingsModalTypes.ADD_COMM_LOOP}
      handleClose={handleClose}
      handleSubmit={commLoopModalSubmit}
      title={t('commLoops.addCommLoop')}
      loading={settingsModal?.get('loading')}
      fields={
        fromJS(commLoopFields)
      }
    />
  );
}

AddCommLoopModal.propTypes = {
};

AddCommLoopModal.defaultProps = {
};
